export enum AddressType {
    Billing = 'billing',
    Shipping = 'shipping',
}
export const THUMBNAIL_SCROLL_AMOUNT = 120;
